import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import {
    FlexContainer,
    WrapperContainer,
    ProductListTableContainer,
    EmptyDataContainer,
    NoResults,
    TrySearch,
    NoResultImage,
    ProductsWrapper,
    ImageContainer
} from './ProductList.style'
import SearchBar from '../../components/SearchBar';
import useHttp from "../../axios/useHttp";
import endpoints from "../../axios/endPoints";
import LoadingEffect from "../../components/LoadingEffect";
import { toast } from "react-toastify";

const ProductsListing = (params) => {
    let { org, region } = useParams();
    const {page} = params;
    const [searchParams] = useSearchParams();
    const language = searchParams.get("lang") || 'en';
    const { get } = useHttp();
    const navigate = useNavigate();
    const [query, setQuery] = useState("");
    const [listItems, setListItems] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);
    const [loading, setLoading] = useState(false);

    const searchItems = () => {
        return page =='mifl' ? listItems?.filter((item) =>
            item?.share_class_product_name?.toLowerCase().includes(query?.toLowerCase())
          ): listItems?.filter((item) =>
          item?.product_name?.toLowerCase().includes(query?.toLowerCase())
        );
    }
    
    const getProductsList = async () => {
        setLoading(true)
        try {
            const response = page == 'mifl' ?  await get({endpoint: endpoints.mifl.getProductsList + org }) : await get({endpoint: endpoints.mildac.getProductsList + region }) ;
            const respArray = response.data.map((item) => item)
            setListItems(respArray || [])
            // setFilteredItems(response.data || [])
            setLoading(false)
        } catch (err) {
            console.log(err)
            if(err?.status === 400)
                toast.error(err?.response?.data?.message || "Something went wrong. Please try again later.")
            else {
                toast.error("Something went wrong. Please try again later.")
            }
            setListItems([])
            setLoading(false)
        }
    }

    useEffect(()=> {
        setFilteredItems(searchItems());
    }, [query, listItems])

    useEffect(()=> {
        getProductsList();
    }, [])

    return (
        <FlexContainer justify={'center'} width={'100%'}>
            <WrapperContainer maxwidth={'1440px'}>
                {loading ? <LoadingEffect /> :
                <><SearchBar query={query} onSendData={(e)=>setQuery(e)} width={'300px'}/>
                <hr></hr>
                {/* search button */}
                <ProductsWrapper>
                {filteredItems&& filteredItems?.length ? <ProductListTableContainer>
                    <table>
                        <thead>
                            <tr>
                                <th>Products</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredItems?.map((item, index) => <tr key={index}>
                                <td onClick={()=> {
                                    navigate(page == 'mifl' ? `/${org}/Info/${item?.share_class_isin}/${item?.premium_type}?lang=${language}` 
                                    : `/mildac/${region}/Info/${item.mil_kid_product_code}?lang=${language}`)
                                }}>{page =='mifl' ? item?.share_class_product_name : item.product_name}</td>
                            </tr>)}
                        </tbody>
                    </table>
                </ProductListTableContainer>: 
                <EmptyDataContainer>
                    <div>
                        <NoResults>No results found</NoResults>
                        <TrySearch>Try searching again</TrySearch>
                    </div>
                    <ImageContainer>
                    <NoResultImage src={'/images/no-search-data.svg'} />
                    </ImageContainer>
                </EmptyDataContainer>}
                </ProductsWrapper>
                </> }
            </WrapperContainer>
        </FlexContainer>
    )
}

export default ProductsListing;